import {
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Stack,
  Text
} from '@chakra-ui/react'
import { AiOutlinePlusCircle as PlusIcon } from 'react-icons/ai'
import {
  SERVICE_FREQUENCIES,
  SERVICE_TYPES
} from '../../../resources/ContractedServices'
import { CurrencyInput } from '../../Shared/inputs'

const ContractedServiceItem = ({ index, formik }) => {
  const service = formik.values.contracted_services[index]
  const touched = formik.touched.contracted_services?.[index]
  const errors = formik.errors.contracted_services?.[index]

  const getFieldError = (field) =>
    touched?.[field] && errors?.[field] ? errors[field] : null

  const basePath = `contracted_services[${index}]`
  const otherServices = service.other_services || []
  const hasOtros = (service.service_types || []).includes('OTROS_SERVICIOS')

  const handleFrequencyChange = (event) => {
    const value = event.target.value
    formik.setFieldValue(
      `${basePath}.frequency`,
      value === '' ? '' : Number(value)
    )
  }

  const handleServiceTypeToggle = (serviceType) => {
    const currentTypes = service.service_types || []
    const nextTypes = currentTypes.includes(serviceType)
      ? currentTypes.filter((type) => type !== serviceType)
      : [...currentTypes, serviceType]

    formik.setFieldValue(`${basePath}.service_types`, nextTypes)

    if (serviceType === 'OTROS_SERVICIOS') {
      if (nextTypes.includes('OTROS_SERVICIOS')) {
        // Al activar "Otros servicios" dejar al menos un campo.
        if (otherServices.length === 0) {
          formik.setFieldValue(`${basePath}.other_services`, [''])
        }
      } else {
        formik.setFieldValue(`${basePath}.other_services`, [])
      }
    }
  }

  const handleChangeOther = (otherIndex, value) => {
    const next = [...otherServices]
    next[otherIndex] = value
    formik.setFieldValue(`${basePath}.other_services`, next)
  }

  const handleAddOther = () => {
    formik.setFieldValue(`${basePath}.other_services`, [...otherServices, ''])
  }

  const handleRemoveOther = (otherIndex) => {
    const next = otherServices.filter((_, i) => i !== otherIndex)
    formik.setFieldValue(
      `${basePath}.other_services`,
      next.length ? next : ['']
    )
  }

  return (
    <Stack
      spacing={5}
      border="1px solid #59BABA"
      borderRadius={8}
      p={5}
      marginInline={{ lg: 20 }}
    >
      <FormControl isInvalid={Boolean(getFieldError('service_types'))}>
        <FormLabel>Seleccione los servicios</FormLabel>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
          {SERVICE_TYPES.map((type) => (
            <Checkbox
              key={type.value}
              colorScheme="teal"
              isChecked={(service.service_types || []).includes(type.value)}
              onChange={() => handleServiceTypeToggle(type.value)}
            >
              {type.label}
            </Checkbox>
          ))}
        </SimpleGrid>
        <FormErrorMessage>{getFieldError('service_types')}</FormErrorMessage>
      </FormControl>

      {hasOtros && (
        <FormControl isInvalid={Boolean(getFieldError('other_services'))}>
          <FormLabel>Otros servicios</FormLabel>
          <Stack spacing={3}>
            {otherServices.map((other, otherIndex) => (
              <InputGroup key={otherIndex} size="md">
                <Input
                  value={other}
                  onChange={(event) =>
                    handleChangeOther(otherIndex, event.target.value)
                  }
                  placeholder={`Otro servicio ${otherIndex + 1}`}
                  pr="4.5rem"
                />
                {otherServices.length > 1 && (
                  <InputRightElement width="4.5rem">
                    <Button
                      colorScheme="red"
                      h="1.75rem"
                      size="sm"
                      onClick={() => handleRemoveOther(otherIndex)}
                    >
                      Quitar
                    </Button>
                  </InputRightElement>
                )}
              </InputGroup>
            ))}
          </Stack>
          <FormErrorMessage>{getFieldError('other_services')}</FormErrorMessage>
          <Flex justify="flex-end" mt={3}>
            <Button
              size="sm"
              bg="#FFFFFF"
              color="#59BABA"
              border="1px"
              borderColor="#59BABA"
              leftIcon={<PlusIcon />}
              onClick={handleAddOther}
            >
              Agregar otro servicio
            </Button>
          </Flex>
        </FormControl>
      )}

      <FormControl isInvalid={Boolean(getFieldError('frequency'))}>
        <FormLabel>Frecuencia del servicio</FormLabel>
        <Select
          placeholder="Seleccione"
          name={`${basePath}.frequency`}
          value={service.frequency}
          onChange={handleFrequencyChange}
          onBlur={formik.handleBlur}
        >
          {SERVICE_FREQUENCIES.map((frequency) => (
            <option key={frequency.value} value={frequency.value}>
              {frequency.label}
            </option>
          ))}
        </Select>
        <FormErrorMessage>{getFieldError('frequency')}</FormErrorMessage>
      </FormControl>

      <CurrencyInput
        label="Valor neto facturable"
        name={`${basePath}.billable_value`}
        value={service.billable_value}
        onChange={(value) =>
          formik.setFieldValue(`${basePath}.billable_value`, value)
        }
        onBlur={formik.handleBlur}
        isInvalid={Boolean(getFieldError('billable_value'))}
        errorMessage={getFieldError('billable_value')}
        placeholder="0"
      />
    </Stack>
  )
}

export default ContractedServiceItem
